module.exports = __webpack_public_path__ + "img/06.b91ed2c9.png";